import React from "react";

const TaskDetailLoader = ({
  isExpanded = true,
  sectionKey = "",
  color = ""
}) => {
  if (!isExpanded) {
    return (
      <div className="taskGroupSection">
        <div
          className={`taskGroupHeader taskGroupHeader-${sectionKey} taskGroupHeader-loader`}
          style={{ color: color }}
        >
          <span className="taskGroupTitle">
            <span
              className="linear-background"
              style={{ width: "100px", height: "16px" }}
            />
          </span>
          <i className="material-icons">expand_more</i>
        </div>
      </div>
    );
  }

  // Show full loader when expanded
  return (
    <>
      {Array.from({ length: 10 }, (value, index) => (
        <div
          className="taskTableBodyLoader"
          key={`taskTableBodyLoader${index}`}
        >
          <div className="taskTypeIcon">
            <span className="circle linear-background" />
          </div>
          <div className="taskEmail">
            <span className="linear-background" />
            <span className="linear-background" />
          </div>
          <div className="taskNotes">
            <span className="linear-background" />
          </div>
          <div className="taskDueDate">
            <span className="linear-background" />
          </div>
          <div className="taskActionButtonWrapper">
            <span className="taskActionButton linear-background" />
          </div>
        </div>
      ))}
    </>
  );
};

export { TaskDetailLoader };
export default TaskDetailLoader;
